export const claimPaths = {
  claimForm: "/claim-form",
  reinmbursementClaim: "/reimbursement-claim",
  claimValidation: "/eligibility-verification",
}

export const reportPaths = {
  claimReportV2: "/claim-report-v2",
  lossRatioV5: "/loss-ratio-v5",
}

export const generalPaths = {
  notificationsLogs: "/notification-logs",
  // for notifications module in side bar
  notificationsLogs: "/notification-logs",
  // for the notifications View All button in header dropdown
  dropdownNotifications: "/notifications-logs",
}

export const stakeholderPaths = {
  beneficiaryList: "/beneficiary-list",
  printCertificate: "print-certificate",
}
